__webpack_require__.p = "/ch/fr/customer-service/returns-claims/spareparts/";